import { IconSearch } from '../../../../shared/components/icons/IconSearch'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { TComplaintStatus } from '../../model/types/ComplaintStatus.type'
import { ComplaintStatusBadge } from '../ComplaintStatusBadge'
import { RejectionReasonLabel } from '../RejectionReasonLabel'
import { useAppSelector } from '../../../../app/store/hooks/Redux'
import {
  selectTrademarkInfringementsExpandedRows,
  selectTrademarkInfringementsFilters,
} from '../../model/trademarkInfringementsSlice'
import { TmInfringementRowDomainGeo } from '../../../../app/api'

interface LatestComplaintCellProps {
  infringement_id: number
  complaint_status: TComplaintStatus
  reply_type?: TmInfringementRowDomainGeo['reply_type']
  has_repeat_history: boolean
  onExpand: (infringement_id: number) => void
}

export const LatestComplaintCell = ({
  infringement_id,
  complaint_status,
  reply_type,
  has_repeat_history,
  onExpand,
}: LatestComplaintCellProps) => {
  const { t } = useTranslation()
  const { tab } = useAppSelector(selectTrademarkInfringementsFilters)
  const expandedRows = useAppSelector(selectTrademarkInfringementsExpandedRows)

  return (
    <div className={'flex flex-col gap-[8px]'}>
      <div className={'flex flex-col gap-[4px]'}>
        <ComplaintStatusBadge status={complaint_status} />
        {(complaint_status === 'rejected' || complaint_status === 'disappeared') && (
          <RejectionReasonLabel
            disappeared={complaint_status === 'disappeared'}
            replyType={reply_type}
          />
        )}
      </div>
      {(tab !== 'to_submit' || has_repeat_history) && (
        <button className={'flex items-center gap-[4px]'} onClick={() => onExpand(infringement_id)}>
          <div className={'w-[16px]'}>
            <IconSearch color={'#0E63D8'} />
          </div>

          <span className={'text-left text-focus underline decoration-focus decoration-dotted'}>
            {expandedRows === 'all' || expandedRows.includes(infringement_id)
              ? t('pages.trademarkInfringements.hideDetails')
              : t('pages.trademarkInfringements.viewDetails')}
          </span>
        </button>
      )}
    </div>
  )
}
